import type React from "react";
import { AspectRatio as ShadcnAspectRatio } from "src/shadcn/components/aspect-ratio";

const AspectRatio = (props: React.ComponentProps<typeof ShadcnAspectRatio>) => (
  <ShadcnAspectRatio {...props} />
);

export { AspectRatio };
